/**
 * Amara wallpaper calculator
 */
(function ($) {
  $.fn.amaraWallpaperCalculator = function (options) {
    var isMethodCall = typeof options === "string",
      args = Array.prototype.slice.call(arguments, 0),
      name = "amaraWallpaperCalculator";

    // handle initialization and non-getter methods
    return this.each(function () {
      var instance = $.data(this, name);

      // prevent calls to internal methods
      if (isMethodCall && options.substring(0, 1) === "_") {
        return this;
      }

      // constructor
      !instance &&
        !isMethodCall &&
        $.data(this, name, new $.amaraWallpaperCalculator(this))._init(args);

      // method call
      instance &&
        isMethodCall &&
        typeof instance[options] === "function" &&
        instance[options].apply(instance, args.slice(1));
    });
  };

  $.amaraWallpaperCalculator = function (element) {
    var args = Array.prototype.slice.call(arguments, 0),
      $el;

    if (!element || !element.nodeType) {
      $el = $("<div />");
      return $el.amaraWallpaperCalculator.apply($el, args);
    }

    this.container = $(element);
  };

  /**
   * Static members
   */
  $.extend($.amaraWallpaperCalculator, {
    version: "0.1.0",
    defaults: {
      postcodeInput: "",
    },
  });

  var unitData = {
    m: {
      toCm: 100,
      display: "m",
      dp: 2,
    },
    cm: {
      toCm: 1,
      display: "cm",
      dp: 0,
    },
    inc: {
      toCm: 2.54,
      display: "in",
      dp: 1,
    },
    ft: {
      toCm: 30.48,
      display: "ft",
      dp: 2,
    },
  };

  var getUnit = function (unitScheme, isLargeUnit) {
    if ("metric" == unitScheme) {
      if (isLargeUnit) {
        return "m";
      } else {
        return "cm";
      }
    } else {
      if (isLargeUnit) {
        return "ft";
      } else {
        return "inc";
      }
    }
  };

  var convertToCm = function (value, unitScheme, isLargeUnit) {
    var unit = getUnit(unitScheme, isLargeUnit);

    return value * unitData[unit].toCm;
  };

  var convertFromCm = function (value, unitScheme, isLargeUnit) {
    var unit = getUnit(unitScheme, isLargeUnit);

    return value / unitData[unit].toCm;
  };

  var formatForDisplay = function (valueInCm, unitScheme, isLargeUnit) {
    var value = convertFromCm(valueInCm, unitScheme, isLargeUnit);
    var unit = getUnit(unitScheme, isLargeUnit);

    return value.toFixed(unitData[unit].dp) + " " + unitData[unit].display;
  };

  var getUnitForDisplay = function (unitScheme, isLargeUnit) {
    var unit = getUnit(unitScheme, isLargeUnit);
    return unitData[unit].display;
  };

  var roundUpToMultiple = function (value, multiple) {
    return multiple * Math.ceil(value / multiple);
  };
    console.log(roundUpToMultiple, "roundUpToMultiple");
  /**
   * Non-static members
   */
  $.extend($.amaraWallpaperCalculator.prototype, {
    container: false,
    options: {},

    _init: function (args) {
      var o,
        self = this;
      args = Array.isArray(args) ? args : [];
      args.unshift($.amaraWallpaperCalculator.defaults);
      args.unshift({});

      o = this.options = $.extend.apply($, args);

      // Initialise the units display
      $("#appbundle_wallpaper_calculator_type_units")
        .on("change", function () {
          var units = $(this).val();

          // Update display units
          self.container.find("span.js-unit-m").html(getUnitForDisplay(units, true));
          self.container.find("span.js-unit-cm").html(getUnitForDisplay(units, false));

          // Convert any we need to
          self.container.find("span.js-unit-convert").each(function () {
            var span = $(this);
            var unit = span.data("unit");
            var lengthInCm = span.data("amount");
            var isMeters = unit == "m";

            if (isMeters) {
              lengthInCm *= 100;
            }

            span.html(formatForDisplay(lengthInCm, units, isMeters));
          });
        })
        .trigger("change");

      // Initialise the match type stuff
      $("#appbundle_wallpaper_calculator_type_match_type")
        .on("change", function () {
          var showPatternRepeat = "random" != $(this).val();
          var hereBeDragons = "multi-drop" == $(this).val();

          $("#appbundle_wallpaper_calculator_type_pattern_repeat")
            .parents("div.amaraformitemrow")
            .toggle(showPatternRepeat);

          if (hereBeDragons) {
            $("#wc-room-details").hide();
            $("#wc-results").hide();
            $("#wc-buttons").hide();
            $("#wc-dragons").show();
          } else {
            $("#wc-room-details").show();
            $("#wc-results").show();
            $("#wc-buttons").show();
            $("#wc-dragons").hide();
          }
        })
        .trigger("change");

      // Don't show results initially
      $("#wc-results").hide();

      //dont show add to cart button, while we don't know how many items to add
      $("#wc-add-to-bag").hide();

      this._getForm().on("submit", function (event) {
        // Stop normal form submission
        event.preventDefault();

        // Recalculate wallpaper stuff
        self.calculate();
      });
    },

    calculate: function () {
      var inputs = this._getInputs();
      var results = this._getResults(inputs);
      console.log(inputs, "inputs", results, "results");
      this._drawResults(results);
    },


    _getForm: function () {
      return this.container.find("form");
    },

    _getInputs: function () {
      var units = $("#appbundle_wallpaper_calculator_type_units").val();

      return {
        units: units,
        matchType: $("#appbundle_wallpaper_calculator_type_match_type").val(),
        rollWidth: convertToCm(
          parseFloat($("#appbundle_wallpaper_calculator_type_roll_width").val()),
          units,
          false
        ),
        rollLength: convertToCm(
          parseFloat($("#appbundle_wallpaper_calculator_type_roll_length").val()),
          units,
          true
        ),
        patternRepeat: convertToCm(
          parseFloat($("#appbundle_wallpaper_calculator_type_pattern_repeat").val()),
          units,
          false
        ),
        width: convertToCm(
          parseFloat($("#appbundle_wallpaper_calculator_type_width").val()),
          units,
          false
        ),
        height: convertToCm(
          parseFloat($("#appbundle_wallpaper_calculator_type_height").val()),
          units,
          false
        ),
      };
    },

    _getResults: function (inputs) {
      var results = {
        units: inputs.units,
        strips: {},
        totalLength: 0,
      };

      var strips = Math.ceil(inputs.width / inputs.rollWidth);
      console.log(results);
      console.log(strips);
      switch (inputs.matchType) {
        case "random":
          results.strips.normal = {
            cutLength: inputs.height,
            count: strips,
          };
          break;
        case "straight":
          results.strips.normal = {
            cutLength: roundUpToMultiple(inputs.height, inputs.patternRepeat),
            count: strips,
          };
          break;
        case "half-drop":
          var heightRoundedToRepeat = roundUpToMultiple(inputs.height, inputs.patternRepeat);
          var amountLeftWhenRounded = heightRoundedToRepeat - inputs.height;
          if (amountLeftWhenRounded >= inputs.patternRepeat / 2) {
            // If we have enough wallpaper left when rounded up to
            // cover half a pattern match we are in a case where we
            // can use the same sized strips and waste much less
            // paper

            results.strips.normal = {
              cutLength: roundUpToMultiple(inputs.height, inputs.patternRepeat / 2),
              count: strips,
            };
          } else {
            results.strips.normal = {
              cutLength: heightRoundedToRepeat,
              count: Math.ceil(strips / 2),
            };
            results.strips.longer = {
              cutLength: roundUpToMultiple(
                inputs.height + inputs.patternRepeat / 2,
                inputs.patternRepeat
              ),
              count: Math.floor(strips / 2),
            };
          }
          break;
        default:
          throw new Error("Unknown match type");
      }

      for (var type in results.strips) {
        if (results.strips.hasOwnProperty(type)) {
          results.totalLength += results.strips[type].count * results.strips[type].cutLength;
        }
      }

      results.rolls = Math.ceil(results.totalLength / inputs.rollLength);
      console.log(results.rolls, "results rolls");
      return results;
       
    },

    _drawError: function () {
      $("#wc-results").hide();
    },

     _drawResults: function (results) {
      $("#wc-results").show();
      $("#wc-add-to-bag").show();
      $("#wc-result-rolls").text(results.rolls); 
     },
  });
})(jQuery);